module.exports = __webpack_public_path__ + "static/media/team1.922fca49.jpg";